import { ApiService } from '@flicent/fieldpulse-react-component-library-frontend';

import { MAIN_SERVER_API_ORIGIN } from '@/constants';


export const MainServerApiServiceInstance = new ApiService(MAIN_SERVER_API_ORIGIN);